import { createContext, useContext } from 'react';
import type { MiniAppIconSettings, ThemeMode, ThemePalette } from '../miniapp-ui.types';

export interface MiniAppPlatformValue {
  /** Absent on older hosts → MapView falls back to plain circle markers. */
  icons?: MiniAppIconSettings;
  /** Absent on the iframe host, which sends the mode over its theme bridge → useTheme falls back to that. */
  theme?: ThemeMode;
  /** Same split for the palette variant → useThemePalette falls back to the bridge. */
  palette?: ThemePalette;
  /** The viewer's name from the host, absent when the host has no authenticated user. */
  username?: string;
  /** The deployment's classification banner token (unclassified, cui, secret, …), as the host's own banner reads it; absent when none is configured. */
  classificationBanner?: string;
}

const DEFAULT_VALUE: MiniAppPlatformValue = {};

export const MiniAppPlatformContext = createContext<MiniAppPlatformValue>(DEFAULT_VALUE);

export function useMiniAppPlatform(): MiniAppPlatformValue {
  return useContext(MiniAppPlatformContext);
}
